module.exports = __webpack_public_path__ + "img/online_shopping_02.png";